import { render, staticRenderFns } from "./readyorders.vue?vue&type=template&id=333ef969"
import script from "./readyorders.vue?vue&type=script&lang=js"
export * from "./readyorders.vue?vue&type=script&lang=js"
import style0 from "./readyorders.vue?vue&type=style&index=0&id=333ef969&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports